// @flow
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { createUseStyles } from 'react-jss';

type Props = {
  show: boolean,
  children: React.Element<any> | React.Element<any>[]
}

const useStyles = createUseStyles({
  transition: {
    opacity: '0',
    '&.transition-enter-active, &.transition-enter-done': {
      opacity: '1',
      transition: 'opacity .6s ease-in .1s'
    }
  }
});

const FadeIn = (props: Props) => {
  const { children, show = true } = props;
  const c = useStyles();

  return (
    <CSSTransition
      in={show}
      appear={show}
      classNames="transition"
      timeout={{ enter: 1200 }}
    >
      <div className={c.transition}>
        {children}
      </div>
    </CSSTransition>
  );
};

export default FadeIn;
